import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import Banner1 from '../../images/banner/banner1.jpg';
import PortImage10 from '../../images/industrie/power_industrie.jpg';
import ClientLogo1 from '../elements/client-logo/client-logo-1';

class IndustryPowerRenewables extends Component {

	render(){
		return (
			<>
				<Header1 />

				<div className="page-content bg-white">

					<div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">Power & Renewable Energies</h1>
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
										<li>Industries</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					<div className="content-block" id="content-area">
						
						<div className="section-area section-sp2 port-7-content">
							<div className="container">
								<div className="row">

									<div className="col-lg-7">
										<div className="heading-bx text-left m-b20">
											<h3 className="title-head m-b0">Energy & Renewables Solutions</h3>
											<div className="ttr-separator sepimg"></div>
										</div>

										<p>
											GO-PS provides end-to-end technical expertise for both conventional power generation systems and modern renewable energy technologies.<br/>
We support clients with advanced energy-efficiency programs, electrical infrastructure design, optimisation, and reliability enhancement for industrial and utility-scale operations.<br/>
Our capabilities extend to solar power engineering, wind-energy solutions, hybrid system integration, and smart energy-management platforms that improve performance, reduce costs, and strengthen overall sustainability.<br/>
										</p>
									</div>

									<div className="col-lg-5">
										<div className="row sp4 magnific-image sticky-top">
											<div className="action-card col-lg-12 wow fadeInUp">
												<div className="portfolio-box ">
													<div className="portfolio-media">
														<img src={PortImage10} alt="" style={{ border: "6px solid #ff6600"  }}/>
													</div>
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>

					</div>
					<div className="section-area section-sp2 bg-gray">
							<div className="container wow fadeIn" data-wow-delay="0.8s">
								<div className="heading-bx text-center">
									<h6 className="title-ext m-b0">Our Partner</h6>
									<h2 className="title-head m-b0">Partners & Clients</h2>
									<div className="ttr-separator sepimg"></div>
								</div>
								
								<ClientLogo1 />
						
							</div>
						</div>
				</div>

				<Footer1 />
			</>
		);
	}
}

export default IndustryPowerRenewables;
